export const SCHEME = {
  PAY_WEB: 'payweb', // 페이홈 -> 웹뷰
  MTS_STOCK: 'mts/stock', // 주식탭 -> 종목 상세 (클라)
  MTS_WEB: 'mts/web', // 주식탭 -> 웹뷰
  MTS_DISCOVERY: 'mts/discovery', // 주식탭 -> 발견탭 -> 웹뷰
} as const;
